'use client';

import { c as _c } from "react/compiler-runtime";
import { isHeading } from 'datocms-structured-text-utils';
import { renderNodeRule, StructuredText } from 'react-datocms';
import { Heading } from 'ui';
import { LinkList } from '~/components/LinkList';
import { Interrail } from './interrail';
import styles from './TicketingInstruction.module.css';
import type { SingleInterrailRecord, SingleTodRecord, TicketingInstructionProps } from './TicketingInstruction.types';
import { Tod } from './tod';
type TicketingInstructionContentProps = Pick<TicketingInstructionProps, 'staticContent' | 'dynamicContent'>;
const structuredTextRules = [renderNodeRule(isHeading, ({
  node,
  children,
  key
}) => <Heading as={`h${node.level}`} key={key} className={styles.title}>
      {children}
    </Heading>)];
const renderBlock = (allowTitle = true) => ({
  record
}: {
  record: {
    __typename: string;
    title?: unknown;
    url?: unknown;
  };
}) => {
  switch (record.__typename) {
    case 'LinkListItemRecord':
      if (allowTitle && !record.title) return null;
      return <LinkList items={[{
        url: record.url as string,
        title: record.title as string
      }]} bordered />;
    default:
      return null;
  }
};
export const TicketingInstructionContent = t0 => {
  const $ = _c(12);
  const {
    staticContent,
    dynamicContent
  } = t0;
  const {
    openingInstructions,
    closingInstructions
  } = staticContent;
  let t1;
  bb0: {
    if (!dynamicContent) {
      t1 = null;
      break bb0;
    }
    if ((dynamicContent as {
      __typename: string;
    }).__typename === "InterrailRecord") {
      const t2 = dynamicContent as SingleInterrailRecord;
      let t3;
      if ($[0] !== t2) {
        t3 = <Interrail content={t2} />;
        $[0] = t2;
        $[1] = t3;
      } else {
        t3 = $[1];
      }
      t1 = t3;
      break bb0;
    }
    const t2 = dynamicContent as SingleTodRecord;
    let t3;
    if ($[2] !== t2) {
      t3 = <Tod content={t2} />;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t1 = t3;
  }
  const tickets = t1;
  let t2;
  if ($[4] !== openingInstructions) {
    t2 = openingInstructions && <StructuredText data={openingInstructions} customNodeRules={structuredTextRules} renderBlock={renderBlock(true)} />;
    $[4] = openingInstructions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== closingInstructions) {
    t3 = closingInstructions && <StructuredText data={closingInstructions} customNodeRules={structuredTextRules} renderBlock={renderBlock(false)} />;
    $[6] = closingInstructions;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== tickets) {
    t4 = <div className={styles.content}>{t2}{tickets}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = tickets;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};